import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { AuthService } from './auth.service';

/**
 * Runs `AuthService.loadSession()` before the app renders, so `user` /
 * `isAuthenticated` are populated on the first paint when a token is stored.
 * Add to the root providers.
 */
export function provideAuthSession(): EnvironmentProviders {
  return provideAppInitializer(() => inject(AuthService).loadSession());
}
